// extracted by mini-css-extract-plugin
export default {"cls1":"zGSJ7nZVT5qrcfolxxgA","cls2":"Mse4TDOqcymkHGeW3DsG zGSJ7nZVT5qrcfolxxgA"};